import { Button } from '@crehana/compass.ui/v3/button';
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateTitle,
} from '@crehana/compass.ui/v3/empty-state';

import { useTranslation } from './i18n';

type TAdminConceptFormulaErrorProps = {
  /**
   * Optional so this also works as Modern.js's route-level error element
   * (rendered with no props). The page passes `refetch` over the failed
   * `useConceptCatalog` query; the framework fallback reloads the page.
   */
  onRetry?: () => void;
};

export const AdminConceptFormulaError = ({
  onRetry,
}: TAdminConceptFormulaErrorProps = {}) => {
  const { t } = useTranslation();

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
      return;
    }

    window.location.reload();
  };

  return (
    <div className="tw-w-screen tw-h-screen tw-flex tw-items-center tw-justify-center">
      <EmptyState variant="error">
        <EmptyStateTitle>{t('ERROR_TITLE')}</EmptyStateTitle>
        <EmptyStateActions>
          <Button variant="primary" onClick={handleRetry}>
            {t('ERROR_RETRY_BUTTON')}
          </Button>
        </EmptyStateActions>
      </EmptyState>
    </div>
  );
};
